import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { LaunchesResponseDTO } from '../dtos/response.dtos';
import { LaunchesApis } from '../../../../new-lib/apis/launches.apis';

const useFetchLaunches = (
  initialData: LaunchesResponseDTO,
  pageSize: number,
  selectedAreas: number[]
) => {
  const { locale } = useRouter();
  const { data: launches, status } = useQuery({
    queryKey: ['launches', locale, pageSize, selectedAreas],
    queryFn: () =>
      LaunchesApis.getLaunches(
        {
          pagination: {
            page: 1,
            pageSize: pageSize
          },
          searchTerm: '',
          areaIds: selectedAreas
        },
        locale
      ),
    cacheTime: 86400,
    initialData: initialData,
    keepPreviousData: true
  });

  return { extendedLaunches: launches, status };
};

export default useFetchLaunches;
